<script lang="ts">
	//Stores
	import { devices } from 'src/stores/lists/devices';
	import { sidePanelState } from 'src/stores/ui/sidepanel-public';
	//Components
	import SidepanelViewSwitcher from 'src/components/Sidepanel/SidepanelViewSwitcher.svelte';
	//Helpers
	import { checkIsComponent } from 'src/components/Sidepanel/sidepanel-helpers';
	import { real_id } from 'src/helpers/interface_helpers';
	import DEVICE_SIDE_PANEL_LAYOUT_CONFIG from './device-layout-imports';

	$: device = $devices?.[$sidePanelState.id] || $devices?.[real_id($sidePanelState.id)];
	$: deviceType =
		$sidePanelState.type === 'device' ? device?.type || null : null;
</script>

<div class="sidepanel-device-layout-host">
	{#key deviceType}
		<svelte:component this={checkIsComponent(DEVICE_SIDE_PANEL_LAYOUT_CONFIG?.[deviceType])} />
	{/key}
	<SidepanelViewSwitcher {device} />
</div>

<style>
	.sidepanel-device-layout-host {
		position: relative;
		display: flex;
		flex-direction: column;
		height: 100%;
		min-height: 0;
		flex: 1;
	}

	.sidepanel-device-layout-host :global(.sidepanel-layout) {
		flex: 1;
		min-height: 0;
	}
</style>
